export const countries = ['BE', 'NL', 'FR'];
export const languages = [
    'nl',
    'en',
    'fr',
];
//# sourceMappingURL=index.js.map